import { Transforms, Text, Range } from "slate";
function setActiveTypographyId(editor, id, options) {
  const at = options?.at ?? editor.selection;
  if (!at)
    return;
  Transforms.setNodes(
    editor,
    {
      typography: {
        id,
        style: []
      }
    },
    {
      at,
      match: (node) => Text.isText(node),
      split: Range.isExpanded(at)
    }
  );
}
export {
  setActiveTypographyId
};
//# sourceMappingURL=setActiveTypographyId.js.map